module.exports = __webpack_public_path__ + "static/media/A-empty.6759349d.svg";